import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { ExtractTaskConfigComponent } from 'src/app/librarys/components/app-components/extract-task-config/extract-task-config.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { environment } from 'src/environments/environment';
import { InstanceModuleService } from '../../serves/instance/instance.module';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
declare var $;
@Component({
  selector: 'app-add-resource-list',
  templateUrl: './add-resource-list.component.html',
  styleUrls: ['./add-resource-list.component.css']
})
export class AddResourceListComponent implements OnInit {
  // 接收父组件传值
  @Input() trim:any;
  // 向父组件传值
  @Output() componentState = new EventEmitter();
  userId:string;
  resourceDatas:any = []
  totalPages:number;
  time:any;
  constructor(
    private swMaskService: SwMaskService,
    private instanceModuleService: InstanceModuleService,
    private kmsService: KmsService,
    private box: SwMassageBoxService,
    private create: SwCreateModalComponentService,
    private jwt: SwJwtService,
    private User: GetUserModelService
  ) { }

  ngOnInit() {
    // 获取用户id
    let user = this.User.getUser();
    this.userId = user['userId'];
    this.handleSelectClick();
  }

  // 查询当前用户已选的所有资源
  handleSelectClick(){
    this.resourceDatas = [];
    const params = {
      current: 1,
      size: 1000,
      userId: this.userId
    }
    this.kmsService.queryExtractResourceList(params).subscribe((res) => {
      if(res["code"] == "200"){
        this.resourceDatas = res["data"].records;
        this.totalPages = 0;
        if(this.resourceDatas.length>0){
          this.resourceDatas.forEach(element => {
            element['src'] = element.fileThumbnail ? environment.staticFileUrl + element.fileThumbnail : '';
            if(element.pagesNum){
              const arr = element.pagesNum.split(',');
              this.totalPages += arr.length;
            }else{
              this.totalPages += element.totalPage;
            }
          });
          // 按每页1000字，13字/s 计算时间
          this.time = ((this.totalPages*1000)/13/60/60).toFixed(2);
        }
        $('#selectedResourceNum').text(this.resourceDatas.length);
        this.jwt.setToKen("selectedResourceNum",this.resourceDatas.length);
      }
    })
  }

  // 清空已选的所有资源
  clickEmpty(){
    this.trim.openCLick("确认清空已选的所有资源吗？", (data) => {
      if (data) {
        this.kmsService.removeAllExtractResources(this.userId).subscribe((res) => {
          if (res["code"] == "200") {
            this.box.success("操作成功");
            this.handleSelectClick();
          } else {
            this.box.waring(res.msg);
          }
        });
      }
    });
  }

  // 从已选列表中删除某一条资源
  clickDelete(item){
    this.trim.openCLick("确认移除当前选择的资源吗？", (data) => {
      if(data){
        this.kmsService.deleteExtractResource(item.detailId).subscribe((res) => {
          if (res["code"] == "200") {
            this.box.success("操作成功");
            this.handleSelectClick();
          } else {
            this.box.waring(res.msg);
          }
        });
      }
    })
  }

  // 创建任务
  createTask(){
    if(this.resourceDatas.length == 0){
      this.box.info('请先选择资源!');
      return;
    }
    // if(this.totalPages > 100){
    //   this.box.info('已选资源总页数不能超过100页，请进行筛选移除!');
    //   return;
    // }
    this.create.createModal(ExtractTaskConfigComponent, {});
    this.closeBox();
  }

  // 创建任务并提取
  createTaskAndExtract(){
    if(this.resourceDatas.length == 0){
      this.box.info('请先选择资源!');
      return;
    }
    // if(this.totalPages > 100){
    //   this.box.info('已选资源总页数不能超过100页，请进行筛选移除!');
    //   return;
    // }
    this.swMaskService.openMask('正在创建知识提取任务，请稍候...');
    // 获取任务编号
    this.kmsService.genKeTaskCode().subscribe((res) => {
      if(res.code == "200"){
        // 保存任务信息
        let taskId = this.instanceModuleService.uuid2();
        let params = {
          "contents": [],
          "instances": [],
          "keTask": {
            "status": 2,  // 创建任务并提取，默认将状态改为提取中
            "taskId": taskId,
            "taskNum": res.data,
            "taskType": 0   // 0 根据导入实体清单提取； 1 自由提取
          }
        };
        this.resourceDatas.forEach(element => {
          params.contents.push({
            "materialId": element.materialId,
            "pagesNum": element.pagesNum,
            "taskId": taskId
          });
        });
        this.kmsService.saveKeTask(params).subscribe((res1) => {
          this.swMaskService.closeMask();
          if(res1.code == "200"){
            this.box.success('任务已创建成功,可前往知识提取页面查看提取进度!');
            this.startTask(taskId);
            // 清空已选的所有资源
            $('#selectedResourceNum').text(0);
            this.jwt.setToKen("selectedResourceNum",0);
            this.kmsService.removeAllExtractResources(this.userId).subscribe((res) => {});
            this.componentState.emit('close');
          }else{
            this.box.waring('任务创建失败!');
          }
        })
      }else{
        this.swMaskService.closeMask();
        this.box.waring('获取任务编号失败!');
      }
    })
  }

  // 启动任务
  startTask(taskId){
    this.kmsService.startKeTask(taskId).subscribe(
      data => {
        if (data["code"] == '200') {
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }
  
  // 关闭
  closeBox(){
    this.componentState.emit('close');
  }
}
